export default function toFlattenedObj(objectList) {
  function flattenObject(obj, parentKey = "") {
    let result = {};
    for (const [key, value] of Object.entries(obj)) {
      const newKey = parentKey ? `${parentKey}${key.charAt(0).toUpperCase() + key.slice(1)}` : key;
      if (typeof value === "object" && value !== null) {
        const flattenedChild = flattenObject(value, key);
        for (const [childKey, childValue] of Object.entries(flattenedChild)) {
          if (result.hasOwnProperty(childKey)) {
            // Use camelCase if there is a conflict
            result[newKey + childKey.charAt(0).toUpperCase() + childKey.slice(1)] = childValue;
          } else {
            result[childKey] = childValue;
          }
        }
      } else {
        if (result.hasOwnProperty(key)) {
          result[newKey] = value;
        } else {
          result[key] = value;
        }
      }
    }
    return result;
  }

  return objectList.map((obj) => flattenObject(obj));
}
